"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHighContrastText = exports.calculateIntensity = void 0;

var calculateIntensity = function calculateIntensity(colorObject) {
  var redFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.299;
  var greenFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.587;
  var blueFactor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.114;
  var intensity = Math.round(colorObject.red * redFactor + colorObject.green * greenFactor + colorObject.blue * blueFactor);
  return intensity;
};

exports.calculateIntensity = calculateIntensity;

var getHighContrastText = function getHighContrastText(config) {
  var intensity = config.intensity,
      _config$threshold = config.threshold,
      threshold = _config$threshold === void 0 ? 180 : _config$threshold,
      _config$color = config.color1,
      color1 = _config$color === void 0 ? "#000" : _config$color,
      _config$color2 = config.color2,
      color2 = _config$color2 === void 0 ? "#fff" : _config$color2;
  if (intensity > threshold) return color1;else return color2;
};

exports.getHighContrastText = getHighContrastText;